<template>
  <div id="login-sso-screen">
    <div class="background">
      <img src="@/assets/imgs/header.png">
    </div>
    <cardlogin :cardStyle="'bg-white border-smooth'" :cadastro="false" :noLoginGov="true" :clientId="client_id" :loginSSO="true" @certLoginSSOResponse="certLoginSSOResponse" @loginSSOResponse="loginSSOResponse"/>
  </div>
</template>
<script>
  import Serv from "../services";
  import APIConsulta from "../services/api_consulta";
  import API from "../services/api";
  import { setTimeout } from "timers";
  import cardlogin from '../components/login/card_login';
  import CryptoJSAesJson from "../services/CryptoJSAesJson";

  export default {
    components: {
      cardlogin
    },
    data() {
      return {
        client_id: null,
        loading: false,
        redirectUri: '',
      };
    },
    methods: {
      validateClientId() {
        let secret = this.client_id;
        let servico = process.env.VUE_APP_LOGIN_SSO_SYSTEM.toString().replace(/'/g, '');
        API.get(`consulta-publica/api/authenticate?client_id=${secret}&servico=${servico}`).then((res) => {
          if (!res.data.success) {
            alert('Não Autorizado: Erro ao usar o Login SSO, contate o administrador do site para mais informações.')
            this.$router.push({ name: "home" })
          }
				}).catch((error) => {
          alert('Não Autorizado: Erro ao usar o Login SSO, contate o administrador do site para mais informações.')
          this.$router.push({ name: "home" });
        });
      },
      certLoginSSOResponse(response){
        if(response.resposta){
          console.log(response)
          window.location.replace(`${this.redirectUri}?access_token=${response.access_token}&ssl_token=${response.ssl_token}`);
        }
        else{
          alert('Erro ao realizar login!')
          this.$router.push({ name: "home" });
        }
      },
      loginSSOResponse(response){
        if(response.resposta){
          console.log(response)
          window.location.replace(`${this.redirectUri}?access_token=${response.access_token}`);
        }
        else{
          alert('Erro ao realizar login!')
          this.$router.push({ name: "home" });
        }
      }
    },
    mounted() {
      this.client_id = this.$route.query.client_id;
      this.redirectUri = this.$route.query.redirect_uri;
      this.validateClientId();
    },
  };
</script>

<style scoped>
#login-sso-screen{
  display:flex;
  justify-content:center;
  align-items:center;
  height:100vh;
  width:100vw;
}
.background{z-index:-1;position:absolute;width:100vw;height:100vh;overflow: hidden;background:linear-gradient(180deg, #1ACEB5 0%, #4780F1 100%) 0% 0% no-repeat padding-box;}
.background img {width: 100%;height: 100%;object-fit: cover;mix-blend-mode: multiply;}
</style>